import { render } from "./v-header.vue?vue&type=template&id=9f7eb9a6"
import script from "./v-header.vue?vue&type=script&lang=js"
export * from "./v-header.vue?vue&type=script&lang=js"

import "./v-header.vue?vue&type=style&index=0&id=9f7eb9a6&lang=css"
script.render = render

export default script